import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='SdkUninitializedException' mdxType="Item">
      <p>{`An exception that will be thrown in case the SDK was not initialized properly.
Before calling any of the manager's method, the SDK must be initialized using `}<a parentName="p" {...{
          "href": "/docs/sdk/android/2.x.x/primerHeadlessUniversalCheckout/start"
        }}>{`start`}</a>{` method.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      